import React from 'react';
import { formatNumber } from '../../../../utils';
import { stageDetailText, noOverflow } from '../../../../themes/styles';
import theme from '../../../../themes/CBB/theme';
import Typography from '@material-ui/core/Typography';
import StageDetailsLogo from './StageDetailsLogo';
import StageAmountEdit from './StageAmountEdit';

export default function StageAmount({
  stage,
  edit,
  handleStageUpdate,
  addOrDeleteError,
}) {
  const amount = stage.amount ? formatNumber(stage.amount) : '0,000';

  return (
    <>
      {edit && (
        <StageAmountEdit
          stage={stage}
          handleStageUpdate={handleStageUpdate}
          addOrDeleteError={addOrDeleteError}
        />
      )}
      {!edit && (
        <>
          <StageDetailsLogo imgSrc="general/money_sign.svg" altText="" />
          <Typography
            variant="subtitle1"
            style={{ ...stageDetailText(theme), ...(noOverflow as object) }}
          >
            {amount}
          </Typography>
        </>
      )}
    </>
  );
}
